import { schema as schemas } from 'normalizr'
import qs from 'qs'
import { CallApi } from '@signavio/kraken'

export const collection = 'searchMeta'

export const schema = new schemas.Entity(
  collection,
  {},
  { idAttribute: 'searchTerm' }
)

type FetchQueryType = {
  searchTerm: string
  createdAtFrom?: string
  createdAtTo?: string
}

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ searchTerm, createdAtFrom, createdAtTo }: FetchQueryType) => {
    const query = qs.stringify(
      { searchTerm, createdAtFrom, createdAtTo },
      { addQueryPrefix: true }
    )

    return callApi(`${apiBase}/search/resultsInfo${query}`, schema)
  }
